/**
 * Production catalog — Material Symbols Outlined ligatures CDS will type-check.
 *
 * Storybook can preview any Google ligature; product code takes `IconName` so
 * design and code share one vocabulary. Adding a glyph is adding one name here.
 *
 * Pin (preferred) is `keep`. Google's `pin` is a map pin.
 * Micro (10px) allowlist: `close`, `add`, `check`, `drag_indicator`.
 */
export const ICON_NAMES = [
  "accessibility_new",
  "account_tree",
  "add",
  "add_comment",
  "ads_click",
  "agriculture",
  "alternate_email",
  "anchor",
  "apartment",
  "arrow_back",
  "arrow_downward",
  "arrow_forward",
  "arrow_upward",
  "article",
  "auto_awesome",
  "auto_fix_high",
  "bar_chart",
  "bolt",
  "brush",
  "build",
  "calculate",
  "calendar_today",
  "call",
  "cancel",
  "category",
  "chair",
  "chat_bubble",
  "check",
  "check_box",
  "check_circle",
  "checkroom",
  "chevron_left",
  "chevron_right",
  "circle",
  "close",
  "close_fullscreen",
  "code",
  "content_copy",
  "cooking",
  "credit_card",
  "crop",
  "crop_square",
  "dark_mode",
  "dashboard",
  "data_object",
  "database",
  "delete",
  "description",
  "deployed_code",
  "developer_board",
  "difference",
  "directions_car",
  "done_all",
  "download",
  "drag_indicator",
  "edit",
  "edit_note",
  "error",
  "expand_less",
  "expand_more",
  "extension",
  "factory",
  "file_copy",
  "filter_alt",
  "filter_list",
  "flag",
  "flip",
  "format_paint",
  "function",
  "grid_view",
  "group",
  "home",
  "image",
  "info",
  "inventory_2",
  "keep",
  "keep_off",
  "keyboard_double_arrow_left",
  "keyboard_double_arrow_right",
  "label",
  "layers",
  "left_panel_close",
  "light_mode",
  "link",
  "list",
  "local_library",
  "local_shipping",
  "location_on",
  "lock",
  "logout",
  "mail",
  "memory",
  "menu",
  "merge",
  "more_horiz",
  "more_vert",
  "north_east",
  "notifications",
  "notifications_off",
  "open_in_full",
  "open_in_new",
  "package_2",
  "palette",
  "pause",
  "pending",
  "pie_chart",
  "play_arrow",
  "power",
  "print",
  "progress_activity",
  "receipt",
  "redo",
  "refresh",
  "remove",
  "repeat",
  "restaurant",
  "right_panel_open",
  "save",
  "scatter_plot",
  "schedule",
  "science",
  "search",
  "sell",
  "send",
  "sentiment_satisfied",
  "settings",
  "share",
  "shield",
  "show_chart",
  "smart_toy",
  "smartphone",
  "star",
  "sticky_note_2",
  "swap_vert",
  "table",
  "table_rows",
  "tonality",
  "trending_up",
  "tune",
  "undo",
  "unfold_less",
  "unfold_more",
  "upload",
  "verified_user",
  "vertical_align_bottom",
  "vertical_align_top",
  "view_column",
  "view_list",
  "view_week",
  "visibility",
  "visibility_off",
  "warning",
  "water_drop",
  "widgets",
] as const;

export type IconName = (typeof ICON_NAMES)[number];

export const ICON_NAME_SET: ReadonlySet<string> = new Set(ICON_NAMES);

export const MICRO_ICON_ALLOWLIST = ["close", "add", "check", "drag_indicator"] as const satisfies readonly IconName[];
